/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
//import { selectNodes } from '../utils/cyutils';
//import { selectEdges } from '../utils/cyutils';
//import { selectNodes } from '../utils/cyutils';
import { connectedNodes } from '../utils/cyutils';

const Sidebar = ({data, selection, setSelection, mostrarSoloGrupo, toggleMostrarSoloGrupo, mostrarOrg, toggleMostrarOrg}) => {
  const { groups, elements: { nodes: allNodes }} = data

  // Estado para el texto del filtro
  const [filterText, setFilterText] = useState("");

  // Estado para los nodos filtrados
  const [filteredNodes, setFilteredNodes] = useState(allNodes);

  // Función para manejar el cambio de texto
  const handleInputChange = (e) => {
    setFilterText(e.target.value);
  };

  const handleSelectNode = (nodeId) => {
    setSelection({
      selectedNodes: connectedNodes(nodeId),
      connections: true,
    })
  };

  const handleSelectNodeGroup = (nodeIds) => {
    setSelection({
      selectedNodes: nodeIds,
      connections: false,
    })
  }

  const handleTogleMostrarGrupo = () => {
    toggleMostrarSoloGrupo(!mostrarSoloGrupo)
  }

  const handleTogleMostrarOrg = () => {
    toggleMostrarOrg(!toggleMostrarOrg)
  }

  // Filtrar nodos dinámicamente al cambiar el texto del filtro
  useEffect(() => {
    const lowerCaseFilter = filterText.toLowerCase();

    if (!filterText.trim()) {
      // Si no hay texto en el filtro, no mostrar ningún nodo
      setFilteredNodes([]);
      return;
    }

    const filtered = allNodes.filter((node) => {
      return node.data.label.toLowerCase().includes(lowerCaseFilter)
    });
    setFilteredNodes(filtered);
  }, [filterText, allNodes]);


  return (
    <aside className="sidebar">
      <button className="group-button" onClick={handleTogleMostrarOrg} style={{display: 'none'}}>
        <img src="org.png" alt="mostrar" style={{width:"40px", height:"40px", padding:"5px"}}></img>
        <span>{mostrarOrg? "Mostrar Areas" : "Mostrar Organismos"}</span>
      </button>
      {selection && <button className="group-button" onClick={handleTogleMostrarGrupo}>
        <img src="mostrar.png" alt="mostrar" style={{width:"30px", height:"30px", padding:"5px"}}></img>
        <span>{mostrarSoloGrupo ? "Mostrar todo" : "Mostrar Solo el grupo"}</span>
      </button>}
      <hr/>
      {groups.map(({nodeIds, icono, title}, index) => 
        <button className="group-button" key={index} onClick={() => handleSelectNodeGroup(nodeIds)}>
          <img src={icono} alt={title} style={{width:"40px", height:"40px", padding:"5px"}}></img>
          <span>{title}</span>
        </button>
      )}
      <hr/>
      <div className="icon-text">
        <img src="filtro.png" alt="mostrar" style={{width:"40px", height:"40px", padding:"5px"}}></img>
        <h4>Filtro</h4>
      </div>
      <input 
        type="text" 
        placeholder="Filtrar nodos por etiqueta" 
        value={filterText}
        onChange={handleInputChange}
      />
      <hr/>
      <ul>
        {filteredNodes.map(({ data: { id, label }}) => (
          <ol key={id}
              onClick={() => handleSelectNode(id)}
              style={{
              }}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: label.replace(/[-\n]+/g, "<br>")
              }}
            />
          </ol>
        ))}
      </ul>
    </aside>
  );
};


export default Sidebar;
